import React from 'react';

import { Skeleton } from '../../../skeleton/skeleton';

interface Props {
    count: number;
}

export const SizeOptionsSkeleton = ({ count }: Props) => (
    <ul className='bs-add-to-cart-drawer__size-options'>
        {Array.from({ length: count }).map((_, index) => (
            <li key={index} className='bs-add-to-cart-drawer__size-option'>
                <Skeleton className='bs-add-to-cart-drawer__size-item' />
            </li>
        ))}
    </ul>
);
